module.exports = __webpack_public_path__ + "img/grid.4f66c469.png";